import React, { useState } from 'react';

import { styled, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import LoginSubmitButton from 'containers/LoginPage/components/LoginContinueButton';
import LoginTextField from 'containers/LoginPage/components/LoginTextField';
import globalMessages from 'translations/messages/global-messages';
import { validateEmail } from 'utils/validators';

const Form_Wrapper = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(4),
  margin: theme.spacing(8, 0),
  '& .login-email-field-wrapper': {
    display: 'flex',
    flexDirection: 'column',
  },
  '& .login-email-text': {
    width: 320,
    textAlign: 'center',
  },
}));

const LoginEmailForm = ({ initialValue = '', text, loading, submitLabel, onSubmit }) => {
  const intl = useIntl();
  const [value, setValue] = useState(initialValue);
  const [emailError, setEmailError] = useState(false);

  const handleEmailChange = evt => {
    setValue(evt.target.value);
    if (emailError) setEmailError(false);
  };

  const handleSubmit = async evt => {
    evt.preventDefault();
    if (!validateEmail(value)) setEmailError(true);
    else await onSubmit(value);
  };

  return (
    <Form_Wrapper noValidate className="login-email-form" onSubmit={handleSubmit}>
      <div className="login-email-field-wrapper">
        <LoginTextField
          type="email"
          value={value || ''}
          autoFocus
          placeholder={intl.formatMessage(globalMessages.enter_email)}
          onChange={handleEmailChange}
        />
        {emailError && (
          <Typography variant="caption" color="error">
            {intl.formatMessage(globalMessages.invalid_email)}
          </Typography>
        )}
      </div>
      {text && (
        <Typography className="login-email-text" variant="bodyLight" component="p">
          {text}
        </Typography>
      )}
      <LoginSubmitButton disabled={!value} loading={loading}>
        {submitLabel || intl.formatMessage(globalMessages.continue)}
      </LoginSubmitButton>
    </Form_Wrapper>
  );
};

LoginEmailForm.propTypes = {
  initialValue: PropTypes.string,
  text: PropTypes.string,
  loading: PropTypes.bool,
  submitLabel: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
};

export default LoginEmailForm;
